/* eslint-disable camelcase */
import api from '../_api';

export const entryService = {
  postItem(payload, appointment) {
    if (appointment !== null) {
      return api.post(`/edits/?appointment=${appointment}`, payload);
    }
    return api.post('/edits/', payload);
  },
  cloneItem(id) {
    return api.post(`/clone_edit/${id}/`);
  },
  getItems(args) {
    return api.get('/edits/', {
      params: args,
    });
  },
  getItem(id) {
    return api.get(`/edits/${id}/`);
  },
  deleteItem(id) {
    return api.delete(`/edits/${id}/`);
  },
  likeItem(id) {
    return api.post('/editlikes/', { edit_id: id });
  },
  unlikeItem(id) {
    return api.delete(`/editlikes/${id}`);
  },
  search(query) {
    return api.get(`/edits/?q=${query}`);
  },
  patchItem(item) {
    return api.patch(item.url, item);
  },
  cloneAsTemplate(id) {
    return api.post(`/edits/${id}/clone_as_template/`);
  },
  sendEmail(id, { test_email, test_first_name }, scheduledTime = null) {
    const testparams = test_email || test_first_name ? `&email=${test_email}&first_name=${test_first_name}` : '';
    return api.get(`/blast/${id}/?test=${testparams.length > 0}${testparams}&scheduled=${scheduledTime}`);
  },
  sendGmail(id, payload, scheduledTime = null) {
    return api.post(`/send_gmail/${id}/?scheduled=${scheduledTime}`, payload);
  },
  sendOutlook(id, payload, scheduledTime = null) {
    return api.post(`/send_outlook/${id}/?scheduled=${scheduledTime}`, payload);
  },
  getEditRecipients(editId) {
    return api.get(`/edit_recipients/${editId}/`);
  },
  checkGmailAuth() {
    return api.get('/check_gmail_auth/');
  },
  checkOutlookAuth() {
    return api.get('/check_outlook_auth/');
  },
  getOutlookAuthUrl() {
    return api.get('/get_outlook_auth_url/');
  },
  createOutlookAuthToken(redirect_url) {
    return api.post('/create_outlook_auth_token/', { redirect_url });
  },
  // Deprecated
  getPreview(id, intro = false) {
    return api.get(`/render_edit/${id}/`, { params: { intro } });
  },
  getStats(id) {
    return api.get(`/edits/${id}/stats/`);
  },
  getSentSummary(id) {
    return api.get(`/edits/${id}/sent_summary/`);
  },
  getWeChatForEdit(id) {
    return api.get(`/wechat-edit-qr/${id}/`);
  },
};
